import { ScrollSpyManager } from "./components/ScrollSpyManager.js";

ScrollSpyManager.use();
